import { useState, useCallback } from "react"
import { disconnectIntegrationConnectionApi } from "@/api/integrations"

/**
 * Hook to disconnect integration connections
 */
export function useDisconnectIntegration() {
  const [disconnecting, setDisconnecting] = useState(false)

  const disconnect = useCallback(async (connectionId: string): Promise<boolean> => {
    try {
      setDisconnecting(true)
      await disconnectIntegrationConnectionApi({ connectionId })
      return true
    } catch (error) {
      console.error("Failed to disconnect:", error)
      return false
    } finally {
      setDisconnecting(false)
    }
  }, [])

  return {
    disconnect,
    disconnecting,
  }
}